import { Drawer, Empty } from "antd";
import React from "react";
import { CONSTANT } from "../../../../config/Constant";

const ViewWebhook: React.FC<any> = (props) => {
  const { openViewWebhook, setOpenViewWebhook } = props;

  const close = () => {
    setOpenViewWebhook(false);
  };

  const renderData = (data: any) => (
    <div style={{ whiteSpace: "pre-wrap" }}>
      {JSON.stringify(data, null, 5)}
    </div>
  );

  return (
    <Drawer
      open={openViewWebhook}
      onClose={close}
      destroyOnClose
      width={900}
      footer={false}
      title={`View Webhook`}
    >
      {openViewWebhook === CONSTANT.NO_DATA_FOUND ? (
        <Empty />
      ) : (
        renderData(openViewWebhook)
      )}
    </Drawer>
  );
};

export default ViewWebhook;
